/* eslint-disable no-debugger */
import { takeLatest, put, all, call } from "redux-saga/effects";
import { encryptData } from "../../_common/enode-decode";

import {
  preProsalListChanged,
  preProsalListFailure,
  preProsalListSuccess,
  preProsalSearchChanged,
  preProsalSearchFailure,
  preProsalSearchSuccess,
  preProposalPushToDialSuccess,
  preProposalPushToDialFailure,
} from "./preproposals.action";
import {
  listPreProsal,
  searchPreProsal,
  pushProposalsToDialer,
} from "./preProposals.services";
import PreProposalActionTypes from "./preproposals.types";

/** *********************** SATRT PREPROPOSALS LIST ************************ */
export function* preProsalFetchAllList({ payload }: any) {
  const key: any = "GetAllPreLeadKey";
  try {
    const { CompanyID, Limit } = payload;
    const jsonData: any = {
      CompanyID: CompanyID,
      Limit: Limit,
      InstanceName: payload.InstanceName,
      SortBy: payload.SortBy,
      SortDir: payload.SortDir,
      // ISSUE-017: server-side page size (10/25/50/100 selector)
      RowsPerPage: payload.RowsPerPage ?? 10,
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(listPreProsal, fetchData);
    if (responseData.data.statusCode === "100") {
      yield put(preProsalListFailure(responseData.data));
    } else {
      yield put(preProsalListSuccess(responseData.data));
    }
  } catch (error) {
    yield put(preProsalListFailure(error));
  }
}

export function* preProposalListReset() {
  yield put(preProsalListChanged());
}

export function* onFetchListPreProsal() {
  yield takeLatest(
    PreProposalActionTypes.PREPROPOSAL_LIST_ALL_START,
    preProsalFetchAllList,
  );
}

export function* onPreProposalListFetchResponseReset() {
  yield takeLatest(
    PreProposalActionTypes.PREPROPOSAL_LIST_ALL_RESET_START,
    preProposalListReset,
  );
}

/** *********************** SATRT PREPROPOSALS SEARCH ************************ */
export function* preProsalFetchSearchList({ payload }: any) {
  const key: any = "FetchPreproposalKey";
  try {
    // Forward EVERY field on the payload (basic search + all dialer filters +
    // sort + DND) so the backend filter set actually applies. Previously only
    // the 8 basic fields were forwarded, silently dropping the dialer filters.
    const jsonData: any = {
      ...payload,
      SearchBusinessName: payload.SearchBusinessName ?? "",
      SearchBusinessNumber: payload.SearchBusinessNumber ?? "",
      SearchFromDate: payload.SearchFromDate ?? "",
      SearchToDate: payload.SearchToDate ?? "",
      Limit: payload.Limit ?? 0,
      SearchType: payload.SearchType ?? "Filter",
      CompanyID: payload.CompanyID,
      InstanceName: payload.InstanceName,
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(searchPreProsal, fetchData);
    if (responseData.data.statusCode === "100") {
      yield put(preProsalSearchFailure(responseData.data));
    } else {
      yield put(preProsalSearchSuccess(responseData.data));
    }
  } catch (error) {
    yield put(preProsalSearchFailure(error));
  }
}

export function* preProposalSearchReset() {
  yield put(preProsalSearchChanged());
}

export function* onFetchSearchPreProsal() {
  yield takeLatest(
    PreProposalActionTypes.PREPROPOSAL_LIST_SEARCH_START,
    preProsalFetchSearchList,
  );
}

export function* onPreProposalSearchFetchResponseReset() {
  yield takeLatest(
    PreProposalActionTypes.PREPROPOSAL_LIST_SEARCH_RESET_START,
    preProposalSearchReset,
  );
}

//***********************/

/** *********************** START PUSH TO DIALER ************************ */
export function* preProposalPushToDial({ payload }: any) {
  try {
    const key: any = "PushPreLeadToTCNKey";
    const jsonData: any = {
      InstanceName: payload.instanceName,
      CompanyID: payload.companyID,
      PreLeadID: (payload.preLeadIDs || []).join(","),
      CreatedBy: payload.createdBy,
      CreatedFromDateFilter: payload.createdFromDateFilter || "",
      CreatedToDateFilter: payload.createdToDateFilter || "",
      CompanyName: payload.companyName || "",
      CompanyRegistrationNumber: payload.companyRegistrationNumber || "",
      PushedLeadCount: payload.pushedLeadCount,
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(pushProposalsToDialer, fetchData);

    if (!responseData || responseData.status === "failure") {
      yield put(preProposalPushToDialFailure(responseData));
    } else {
      yield put(preProposalPushToDialSuccess(responseData));
    }
  } catch (error) {
    yield put(preProposalPushToDialFailure(error));
  }
}

export function* onPushProposalsToDialer() {
  yield takeLatest(
    PreProposalActionTypes.PREPROPOSAL_PUSH_TO_DIAL_START,
    preProposalPushToDial,
  );
}

/** *********************** END PUSH TO DIALER ************************ */

export function* preproposalsSaga() {
  yield all([
    call(onFetchListPreProsal),
    call(onPreProposalListFetchResponseReset),
    call(onFetchSearchPreProsal),
    call(onPreProposalSearchFetchResponseReset),
    call(onPushProposalsToDialer),
  ]);
}
